import { LIST, LOADING } from '../../types/role'
// **  Initial State
const initialState = {
  data: [],
  start: 0,
  end: 0,
  totalRecords: 0,
  totalPages: 0,
  percentage: 0,
  params: {},
  loading: true,
  all: [],
}

const role = (state = initialState, action) => {
  switch (action.type) {
    case LIST:
      return {
        ...state,
        data: action.payload.results,
        totalPages: action.payload.totalPages,
        totalRecords: action.payload.totalResults,
        params: { limit: action.payload.limit, page: action.payload.page },
        loading: false,
      }
    case "GET_ROLE_PERMISSION":
      return {
        ...state,
        all: action.payload.results,
      }
    case LOADING:
      return {
        ...state,

        
        loading: action.payload,
      }
    default:
      return state
  }
}

export default role
